import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LandingPage from "./pages/LandingPage";
import ConfiguratorPage from "./pages/ConfiguratorPage";
import StackingPage from "./pages/StackingPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import AdminPage from "./pages/AdminPage";
import TrackOrderPage from "./pages/TrackOrderPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ClearancePage from "./pages/ClearancePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import PVCConfiguratorPage from "./pages/PVCConfiguratorPage";
import EngineeredConfiguratorPage from "./pages/EngineeredConfiguratorPage";
import UnsubscribePage from "./pages/UnsubscribePage";
import ReviewPage from "./pages/ReviewPage";
import GuideIndexPage from "./pages/GuideIndexPage";
import GuideDetailPage from "./pages/GuideDetailPage";
import GuideComparePage from "./pages/GuideComparePage";
import NewsletterPopup from "./components/NewsletterPopup";
import WhatsAppButton from "./components/WhatsAppButton";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[hsl(0,0%,4%)] flex flex-col">
            <div className="noise-overlay" />
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/configurator" element={<ConfiguratorPage />} />
                <Route path="/stacking" element={<StackingPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/checkout/cancel" element={<CheckoutCancel />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/track" element={<TrackOrderPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/clearance" element={<ClearancePage />} />
                <Route path="/pvc" element={<PVCConfiguratorPage />} />
                <Route path="/pvc-configurator" element={<PVCConfiguratorPage />} />
                <Route path="/engineered" element={<EngineeredConfiguratorPage />} />
                <Route path="/engineered-configurator" element={<EngineeredConfiguratorPage />} />
                <Route path="/guides" element={<GuideIndexPage />} />
                <Route path="/guides/compare" element={<GuideComparePage />} />
                <Route path="/guides/:slug" element={<GuideDetailPage />} />
                <Route path="/track-order" element={<TrackOrderPage />} />
                <Route path="/unsubscribe" element={<UnsubscribePage />} />
                <Route path="/review" element={<ReviewPage />} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/terms" element={<TermsOfServicePage />} />
              </Routes>
            </main>
            <Footer />
            <NewsletterPopup />
            <WhatsAppButton />
            <Toaster position="bottom-right" theme="dark" />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
